export default function HowItWorksSection() {
  const steps = [
    {
      number: "01",
      title: "Call or Order Online (Today)",
      description: "Call 877-253-0084 or start your order at fastpassportcenter.com. Tell us your travel date. We'll assess your situation immediately and tell you exactly which processing tier fits your timeline. If you call during business hours, a real passport specialist answers — not a chatbot.",
      icon: "ri-phone-line",
      accent: "bg-red-600",
    },
    {
      number: "02",
      title: "Gather & Submit Your Documents (Same Day)",
      description: "We give you a precise checklist of exactly what you need. You gather your documents and either drop them at one of our 24 nationwide locations or overnight them to us. Speed here is critical — the sooner your documents are in our hands, the sooner we can submit.",
      icon: "ri-file-list-3-line",
      accent: "bg-red-600",
    },
    {
      number: "03",
      title: "Hand-Courier Submission to Passport Agency (Next Business Day)",
      description: "Our registered couriers physically hand-deliver your application to the U.S. passport agency using our reserved daily submission slots. These slots are not available to the public. Your application is processed the same day it arrives at the agency — no mail queues, no waiting rooms.",
      icon: "ri-mail-send-line",
      accent: "bg-red-600",
    },
    {
      number: "04",
      title: "Overnight Return Delivery",
      description: "Your new passport ships back to you via overnight FedEx the moment the agency releases it. Real-time tracking the entire way. Most emergency customers receive their passport within 24 hours of agency release.",
      icon: "ri-plane-line",
      accent: "bg-red-600",
    },
  ];

  return (
    <section id="how-it-works" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-red-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">The Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How <span className="text-red-600">Emergency Passport Processing</span> Works
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            There is no magic button. An emergency passport goes through the same U.S. Department of State system as any other passport — but a registered courier with reserved daily agency access can get it processed as fast as humanly possible within that system. Here's how.
          </p>
        </div>

        <div className="space-y-0">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col md:flex-row gap-5 md:gap-8 pb-10 md:pb-14 last:pb-0">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute left-[39px] top-[72px] w-0.5 h-[calc(100%-24px)] bg-red-400/30"></div>
              )}
              <div className="flex-shrink-0 flex md:flex-col items-center md:items-start">
                <div className={`w-20 h-20 flex items-center justify-center rounded-full ${step.accent} flex-shrink-0`}>
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <div className="md:hidden ml-4 text-red-500 text-xs font-bold">{step.number}</div>
              </div>
              <div className="flex-1 pt-1">
                <span className="hidden md:inline-block text-red-500 text-xs font-bold uppercase tracking-[0.15em] mb-1">{`Step ${step.number}`}</span>
                <h3 className="font-serif text-xl md:text-2xl font-bold text-[#1A365D] mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm md:text-base leading-relaxed max-w-lg">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084 Now
          </a>
        </div>
      </div>
    </section>
  );
}